export default {
  default: {
    gridView: 'Grid View',
    listView: 'List View',
  },
}
